import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { ApiService } from 'src/app/services/api.service'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { HttpError } from 'src/utils/errors'
import { subscriptionActive } from 'src/utils/rxjs-utils'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  resetSubmitted = false
  // Inline error message for validation failures (e.g. invalid email format)
  errorMessage: string = null

  private resetSubscription: Subscription = null
  private resetPasswordForm = this.formBuilder.group({
    email: ['', [Validators.email, Validators.required]],
  })

  constructor(
    private formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private uiService: UiService
  ) {}

  ngOnInit() {}

  resetPassword() {
    this.errorMessage = null
    let email = this.resetPasswordForm.value.email
    this.resetSubscription = this.apiService
      .startResetPassword(email)
      .pipe(
        finalize(() => {
          this.resetSubscription = null
        })
      )
      .subscribe(
        () => {
          this.resetSubmitted = true
        },
        (error) => {
          // The submit button is disabled until the email passes Angular validation, so 422 shouldn't
          // normally be reachable — but kept as a safety net in case the API is stricter than the client
          if (error instanceof HttpError && error.responseCode === 422) {
            this.errorMessage = 'Please enter a valid email address.'
            return
          }
          handleArpioError(window.location.href, this.apiService, this.uiService)(error)
        }
      )
  }

  get submitButtonEnabled() {
    return this.resetPasswordForm.valid && !this.resetting
  }

  get resetting() {
    return subscriptionActive(this.resetSubscription)
  }
}
